export {
  PlaylistItemCarousel,
  PlaylistTileGrid,
  ResponsivePlaylistDisplay,
} from './CommunityProfileCarousels'
export type { CarouselItem, EditToolbarLabels } from './CommunityProfileCarousels'

// Row-level skeleton state — rendered between shell-settled and
// hydration-resolved (PR 11).  Viewport-aware: grid on mobile, row-v2
// carousel-shaped markup on desktop.
export { default as PlaylistItemCarouselSkeleton } from './PlaylistItemCarouselSkeleton'

// Grid-only skeleton — N tile skeletons in the `.playlist-tile-grid`
// layout, used by SystemPlaylistFullView (always grid) and as the mobile
// delegate for PlaylistItemCarouselSkeleton.
export { default as PlaylistGridSkeleton } from './PlaylistGridSkeleton'

// Single-tile skeleton — mirrors the tile-v2 DOM 1:1 (hero, optional
// series-label badge, title line, sub-line).  Building block for the
// row and grid skeletons above.
export { default as TileV2Skeleton } from './TileV2Skeleton'

// Re-export extracted modules for backward compatibility
export { default as useIsMobile } from '../../../../../services/community/shared/useIsMobile'
